import {
  Button,
  Card,
  CardContent,
  CardMedia,
  IconButton,
  Link,
  MdArrowForward,
  MdCancel,
  Stack,
  Typography,
} from '@bymason-private/legacy-pattern-components';
import { pxToRem } from '@bymason/utils';
import {
  ControllerVersion,
  useSelectedControllerPref,
  useShowNewControllerTooltip,
} from '../../global-state';
import { PopupDataModel } from './data';
import { ackPopup } from './utils';

export type PopupCardProps = PopupDataModel & { index: number; setShow: (show: boolean) => void };

export function PopupCard({
  index,
  heroText,
  buttonLabel,
  learnMoreLink,
  imageLink,
  setShow,
}: PopupCardProps) {
  const [, setShowNewControllerTooltip] = useShowNewControllerTooltip();
  const [, updateSelectedControllerVersion] = useSelectedControllerPref();

  const handleClosePopup = () => {
    ackPopup(index);
    setShow(false);
    setTimeout(() => {
      setShowNewControllerTooltip(true);
    }, 500);
  };

  const handleSwitchToNewController = () => {
    ackPopup(index);
    updateSelectedControllerVersion(ControllerVersion.ControllerV2);
  };

  return (
    <Card
      sx={{
        position: 'fixed',
        bottom: 0,
        right: 0,
        borderRadius: 5,
        backgroundColor: 'text.primary',
        m: '32px',
        height: '200px',
        width: '450px',
        display: 'flex',
        p: 1,
        zIndex: 100,
      }}
      data-popup-card-index={index}
    >
      <IconButton
        disableRipple
        sx={{
          position: 'absolute',
          top: -3,
          right: -3,
          color: 'white',
        }}
        onClick={handleClosePopup}
      >
        <MdCancel />
      </IconButton>
      <CardContent sx={{ width: '50%', height: '100%', direction: 'column' }}>
        <Stack height='100%' sx={{ py: 2 }}>
          <Typography
            sx={{
              color: (theme) => theme.palette.common.white,
              mb: 'auto',
              fontSize: pxToRem(15),
              fontWeight: 'bold',
            }}
          >
            {heroText}
          </Typography>
          <Button
            variant='contained'
            color='primary'
            sx={{ mb: 2, px: 2, width: 'fit-content' }}
            endIcon={<MdArrowForward />}
            onClick={handleSwitchToNewController}
          >
            {buttonLabel}
          </Button>
          <Link
            fontSize='12px'
            href={learnMoreLink}
            target='_blank'
            sx={{ color: (theme) => theme.palette.common.white }}
          >
            Learn More
          </Link>
        </Stack>
      </CardContent>
      <CardMedia
        component='img'
        sx={{ width: '50%', height: '100%', objectFit: 'contain', pr: 2 }}
        image={imageLink}
        alt={heroText}
      />
    </Card>
  );
}
